import { render, staticRenderFns } from "./projectPaymentsAndReceiptsesList.vue?vue&type=template&id=66f79fa4&scoped=true"
import script from "./projectPaymentsAndReceiptsesList.vue?vue&type=script&lang=ts"
export * from "./projectPaymentsAndReceiptsesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f79fa4",
  null
  
)

export default component.exports